import React from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import ActivationErrorContent from '../components/AccountActivationError/ActivationErrorContent';
import $ from 'jquery';

export default function AccountActivationError() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/ConfirmationError',
    title: 'Account Activation Error',
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Account Activation Error</title>
        <meta
          name="description"
          content="There was a problem activating your DISGENET account. Try logging in or contact support."
        />
      </Helmet>
      <ActivationErrorContent />
    </React.Fragment>
  );
}
